import { ConcertResponse } from 'api/responseTypes';
import { EventHeader } from 'components/EventHeader/EventHeader';

type ConcertInfoProps = ConcertResponse;

export const GeneralConcertInfo = ({
  title,
  subtitle,
  date,
  time,
  stadium,
  imageLink,
  city,
  arDescription,
  location,
  eventKey,
  isFreeEvent,
  hasTimeslots,
}: ConcertInfoProps) => (
  <EventHeader
    variant='concert'
    title={title}
    subtitle={subtitle}
    imageLink={imageLink}
    date={date}
    time={time}
    stadium={stadium}
    city={city}
    arDescription={arDescription}
    locationHtml={location}
    eventKey={eventKey}
    eventName={title}
    isFreeEvent={isFreeEvent}
    hasTimeslots={hasTimeslots}
  />
);
